import { Popover } from "@headlessui/react";
import { ChevronDownIcon, UserIcon } from "lucide-react";
import type { Customer } from "cy-api/simple-payments/customer/models";
import type { Nil } from "cy-util";
import { joinStrings } from "cy-util";
import { RoundIcon } from "cy-ui/components/RoundIcons";
import { cn } from "cy-fe/src/utils/cn";
import { UnstyledButton } from "cy-fe";
import { ReactNode } from "react";

export function UserProfile({
  popover,
  customer,
}: {
  popover: (close: () => void) => ReactNode;
  customer: Customer | Nil;
}) {
  return (
    <Popover as="div" className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            as={UnstyledButton}
            className="-m-1.5 flex items-center rounded-lg p-1.5 hover:bg-gray-100"
          >
            <span className="sr-only">Open user menu</span>
            <RoundIcon icon={UserIcon} />
            <span className="hidden lg:flex lg:items-center">
              <span
                aria-hidden="true"
                className="ml-2 text-sm leading-6 font-semibold text-gray-900"
              >
                {customer
                  ? joinStrings(
                      customer.name.first_name,
                      customer.name.last_name,
                    )
                  : "Me"}
              </span>
              <ChevronDownIcon
                aria-hidden="true"
                className={cn(
                  "ml-2 h-5 w-5 text-gray-400 transition-all",
                  open && "rotate-180",
                )}
              />
            </span>
          </Popover.Button>
          {popover(close)}
        </>
      )}
    </Popover>
  );
}
